import script from "./AddFriend.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddFriend.vue?vue&type=script&setup=true&lang=ts"

import "./AddFriend.vue?vue&type=style&index=0&id=05e838d8&scoped=true&lang=css"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e838d8"]])

export default __exports__